import { css } from '@emotion/react';
import { ReactNode } from 'react';
import { theme } from 'styles/theme';

export const SummaryLine = ({ label, children }: { label: string; children: ReactNode }) => {
	return (
		<div
			css={css`
				display: flex;
				justify-content: space-between;
				width: 100%;
				margin: 8px 0;

				&:hover {
					background: ${theme.color.primary['50']};
				}
			`}
		>
			<div
				css={css`
					color: ${theme.color.text['300']};
					margin-right: 24px;
				`}
			>
				{label}
			</div>
			<div
				css={css`
					word-wrap: break-word;
					max-width: 60%;
					width: 60%;
				`}
			>
				{children}
			</div>
		</div>
	);
};
